import { SET_ERROR } from '../mutations/common.mutations';
import { FETCH_RESOURCE } from '../actions/resource.actions';
import { TRY_FETCH_RESOURCE, SET_RESOURCE } from '../mutations/resource.mutations';
import ResourceService from '@/common/services/resource.service';
import { getError } from '@/common/services/http.service';

const state = {
  pending: false,
  errors: [],
  resource: null,
  loaded: false
};

const actions = {
  [FETCH_RESOURCE](context) {
    return new Promise((resolve, reject) => {
      context.commit(TRY_FETCH_RESOURCE);

      ResourceService.getResourcePage()
        .then(data => {
          context.commit(SET_RESOURCE, data);
          resolve(data);
        })
        .catch(response => {
          context.commit(SET_ERROR, getError(response));
          reject('Error loading resources');
        });
    });
  },
};

const mutations = {
  [TRY_FETCH_RESOURCE](state) {
    state.pending = true;
    state.errors = [];
  },
  [SET_ERROR](state, errors) {
    state.pending = false;
    state.errors = errors;
  },
  [SET_RESOURCE](state, resource) {
    state.pending = false;
    state.errors = [];
    state.resource = resource;
    state.loaded = true;
  }
};

const getters = {
  resource: state => {
    return state.resource;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
